import api from '@/services/utils/base';
import config from 'src/config';
import store from '@/store';
import _ from 'lodash';

export const availablePlanLimits = ['dataRetention', 'eventsAmount', 'domainsAmount', 'campaignsAmount', 'offersAmount', 'landingsAmount', 'flowsAmount', 'trafficSourcesAmount', 'affiliateNetworksAmount', 'customColumnsAmount', 'memberAdminsAmount', 'memberUsersAmount', 'bulkEditCampaigns', 'bulkEditOffers', 'bulkEditLandings','integrationMgid','integrationExoclick','integrationPropellerads','integrationFacebookConversions','integrationRevcontent','integrationTrafficjunky','webViewCondition', 'crawlerCondition','proxyCondition','referrerDomainCondition', 'visitCapCondition','botMarkCondition', 'uniquenessPeriodCondition', 'doubleMetaRedirect', 'uniquenessPeriod', 'bulkReportCampaign', 'bulkReportOffer', 'bulkReportLanding', 'bulkReportFlow', 'bulkReportTrafficSource', 'bulkReportAffiliateNetwork', 'importOffers', 'importLandings', 'markersCampaigns', 'markersOffers', 'markersLandings', 'markersFlows', 'markersAffiliateNetworks', 'markersTrafficSources', 'markersCustomParams', 'trafficSourceParamMasking', 'botFiltersAccess', 'redirectDomainsAmount', 'customConversionsAmount', 'sharedReportsAmount', 'sendPostbacksCampaign', 'trafficLossCampaign', 'landingPageProtection', 'tagsCampaigns', 'tagsOffers', 'tagsLandings', 'tagsFlows', 'tagsTrafficSources', 'tagsAffiliateNetworks', 'smartRotations', 'bulkReportCustomParams', 'bulkReportBrowserNames', 'bulkReportBrowserVersions', 'bulkReportCities', 'bulkReportConnectionTypes', 'bulkReportCountries', 'bulkReportDay', 'bulkReportDayOfWeek', 'bulkReportDeviceModels', 'bulkReportDeviceTypes', 'bulkReportDeviceVendors', 'bulkReportHourOfDay', 'bulkReportIp', 'bulkReportIsp', 'bulkReportLanguages', 'bulkReportMobileCarriers','bulkReportMonth', 'bulkReportOs', 'bulkReportOsVersions', 'bulkReportReferrerDomains', 'bulkReportReferrers', 'bulkReportScreenResolutions', 'bulkReportStatesRegions', 'bulkReportSubnetBig', 'bulkReportSubnetSmall', 'bulkReportUserAgents', 'ivtIpIsDatacenter', 'ivtIpIsBlacklisted', 'ivtFastClicker', 'ivtIpWithFrequentCampaignEvents', 'ivtIpWithFrequentEvents','uniqOfferViewerCondition','presetAmount','compareReport','externalIdCondition']

export default class Billing{
  getPlans() {
    return api
      .get('billing/plans')
      .then((res: any) => {
        const resultPrepared = res.data.payload.map((plan)=>({
          ...plan,
          limits: {
            ..._.pick(plan.limits, availablePlanLimits),
          },
        }))
        store.commit('setBillingPlans', resultPrepared);
        return Promise.resolve(resultPrepared);
      })
      .catch((err: any) => {
        return Promise.reject();
      });
  }

  getCustomer() {
    return api
      .get('billing/customer')
      .then((res: any) => {
        store.commit('setBillingCustomer', res.data.payload);
        return Promise.resolve(res.data.payload);
      })
      .catch((err: any) => {
        return Promise.reject(err);
      });
  }

  getInvoices() {
    return api
      .get('billing/invoices')
      .then((res: any) => {
        return Promise.resolve(res.data.payload);
      })
      .catch((err: any) => {
        return Promise.reject(err);
      });
  }

  getSubscriptions() {
    return api
      .get('billing/subscriptions')
      .then((res: any) => {
        res.data.payload = {
          ...res.data.payload,
          limits: {
            ..._.pick(res.data.payload.limits, availablePlanLimits),
          },
          usage: {
            ..._.pick(res.data.payload.usage, availablePlanLimits),
          },
        };
        store.commit('setBilling', res.data.payload);
        return Promise.resolve(res.data.payload);
      })
      .catch((err: any) => {
        return Promise.reject(err);
      });
  }

  postUpdateBillingInfo(payload: object) {
    return api
      .post('billing/billing-info', payload)
      .then((res: any) => {
        return Promise.resolve(res.data.payload);
      })
      .catch((err: any) => {
        return Promise.reject(err);
      });
  }

  postUpdateCard(payload: object, meta: any = {}) {
    return api
      .post('billing/card', payload, { meta } as any)
      .then((res: any) => {
        return Promise.resolve(res.data.payload);
      })
      .catch((err: any) => {
        console.log(
          `%c${JSON.stringify(err.response.data, null, 2)}`,
          'color: #ff0000; font-weight: bold; font-size: 12px'
        );
        return Promise.reject(err);
      });
  }

  setupIntent(payload: { paymentMethodId: string }) {
    return api
      .post('/v1/billing/stripe/setup-intent', payload)
      .then((res: any) => {
        return Promise.resolve(res.data.payload);
      })
      .catch((err: any) => {
        return Promise.reject(err);
      });
  }

  postUpdateSubscriptions(payload: any, meta: any = {}) {
    return api
      .post('billing/subscriptions', payload, { meta } as any)
      .then((res: any) => {
        return Promise.resolve(res.data.payload);
      })
      .catch((err: any) => {
        return Promise.reject(err);
      });
  }

  postUpdateSubscriptionsEstimated(payload: any, meta: any = {}) {
    return api
      .post('billing/subscriptions?type=estimates', payload, { meta } as any)
      .then((res: any) => {
        return Promise.resolve(res.data.payload);
      })
      .catch((err: any) => {
        return Promise.reject(err);
      });
  }

  postActivateProTrial() {
    return api.post('billing/activate-pro-trial', {});
  }

  getUnpaidInvoices() {
    return api.get('billing/invoices-unpaid');
  }

  collectUnpaidInvoices() {
    return api.post('billing/collect-payment-invoices', {});
  }

  postApplyPromo(payload: object) {
    return api.post('billing/apply-promo', payload);
  }

  stripePaymentIntent(payload: Billing.StripePaymentIntent) {
    return api.post('billing/stripe/payment-intent', payload);
  }

  stripePaymentSource(payload: Billing.StripePaymentSourceCreate) {
    return api.post('billing/stripe/source', payload);
  }
  
  getAddons() {
    return api
      .get('billing/addons')
      .then((res: any) => {
        store.commit('setBillingAddons', res.data.payload);
        return Promise.resolve(res);
      })
      .catch((err: any) => {
        return Promise.reject();
      });
  }
  
  manageAddon({type,id,quantity}:{type?: null | 'estimates',id:keyof BillingLimits ,quantity?:number}) {
    let url = 'billing/addon'
    if(type==='estimates'){
      url=`${url}?type=estimates`
    }

    return api
      .put(url, { 
        id,
        ...(quantity!==null && {quantity})
      })
      .then((res: any) => {
        if(type!=='estimates'){
          store.commit('setBilling', res.data.payload);
        }
        return Promise.resolve(res);
      })
  }
  
  deleteAddon({type,id}:{type?:'estimates',id:keyof BillingLimits}) {
    let url = `billing/addon/${id}`
    if(type==='estimates'){
      url=`${url}?type=estimates`
    }
    
    return api
      .delete(url)
      .then((res: any) => {
        if(type!=='estimates'){
          store.commit('setBilling', res.data.payload);
        }
        return Promise.resolve(res);
      })
  }
}
